<template>
  <div
    class="schedule-approval-box flex-auto flex-valign"
    style="overflow: hidden"
  >
    <div class="schedule-approval-tab-box">
      <div
        :class="[
          'approval-title-btn',
          activeTitleIndex === index ? 'active' : '',
        ]"
        v-for="(item, index) in selectTitleList"
        :key="index"
        @click="handleTitleTabClick(index)"
      >
        {{ item }}
      </div>
    </div>
    <div v-if="activeTitleIndex == 0" class="schedule-approval-content-box">
      <appointApproval ref="refAppointApproval"></appointApproval>
    </div>
    <div v-else class="schedule-approval-content-box">
      <exitApproval ref="refExitApproval"></exitApproval>
    </div>
  </div>
</template>
<script>
import appointApproval from "../components/AppointApproval.vue";
import exitApproval from "../components/ExitApproval.vue";
export default {
  components: {
    appointApproval,
    exitApproval,
  },
  data() {
    return {
      activeTitleIndex: 0,
      selectTitleList: ["调度入园审批", "调度出园审批"],
    };
  },
  mounted() {
    console.log("-index-mounted()-");
    // this.$refs.refAppointApproval.getUnApprovalList();
  },
  methods: {
    handleTitleTabClick(index) {
      console.log("-handleTitleTabClick:-", index);
      this.activeTitleIndex = index;
      if (this.activeTitleIndex == 0) {
        this.$nextTick(() => {
          this.$refs.refAppointApproval.getUnApprovalList();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.refExitApproval.getUnApprovalList();
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.schedule-approval-box {
  width: 100%;
  height: 100%;
  .schedule-approval-tab-box {
    width: 100%;
    height: 40px;
    margin-bottom: 15px;
    background: white;
    padding: 0 0 0px 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .approval-title-btn {
      width: 100px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: black;
      cursor: pointer;
      font-size: 14px;
      background: white;
    }
    .approval-title-btn:hover {
      width: 100px;
      height: 32px;
      font-size: 14px;
      color: white;
      background: #0d4c9e;
    }
    .active {
      width: 100px;
      height: 32px;
      font-size: 14px;
      color: white;
      background: #0d4c9e;
    }
  }
  .schedule-approval-content-box {
    width: 100%;
    height: calc(100% - 65px);
  }
}
</style>
